import type { LoanApplicationInput } from "@/generated/graphql"
import { map, type MapStore } from "nanostores"

interface LoanState {
  updates: LoanApplicationInput
  sentToServer: LoanApplicationInput[]
}
type LoanStateCache = Record<string, MapStore<LoanState>>

const _loanStates: LoanStateCache = {}
export function getLoanUpdateStore(loanId: string) {
  if (_loanStates[loanId]) {
    return _loanStates[loanId]
  }

  return (_loanStates[loanId] = map({ updates: {}, sentToServer: [] }))
}

export function addLoanUpdates(loanId: string, input: LoanApplicationInput) {
  const map = getLoanUpdateStore(loanId)
  map.setKey("updates", { ...map.get().updates, ...input })
}

export function setLoanUpdates(loanId: string, input: LoanApplicationInput) {
  const map = getLoanUpdateStore(loanId)
  map.setKey("updates", input)
}

// Fully clears all client-side state for a loan — both the pending `updates`
// and the `sentToServer` history. Use this when starting a fresh quote so
// numbers from a previous inquiry don't leak into the new one via the
// `sentToServer` merge in the setup layout.
export function resetLoanState(loanId: string) {
  const map = getLoanUpdateStore(loanId)
  map.set({ updates: {}, sentToServer: [] })
}

export function pushToServer(loanId: string) {
  const map = getLoanUpdateStore(loanId)
  const updates = map.get().updates
  const sentToServer = map.get().sentToServer || []
  map.set({
    updates: {},
    sentToServer: [...sentToServer, updates],
  })
  return updates
}

export function updatedFromServer(loanId: string) {
  const map = getLoanUpdateStore(loanId)
  map.setKey("sentToServer", [])
}
